import { useEffect } from "react";

/**
 * Custom hook to update the document title and track page views for Google Analytics
 * @param {string} title - The title to set for the page
 * @param {string} suffix - Optional suffix to append (defaults to "Tuatara")
 */
const usePageTitle = (title, suffix = "Tuatara") => {
  useEffect(() => {
    const previousTitle = document.title;

    // Set the new title
    if (title) {
      document.title = `${title} | ${suffix}`;
    } else {
      document.title = suffix;
    }

    // Small delay to ensure title is set before tracking
    const timer = setTimeout(() => {
      // Track page view with Google Analytics (gtag) if available
      if (typeof window !== "undefined" && window.gtag) {
        window.gtag("event", "page_view", {
          page_title: document.title,
          page_location: window.location.href,
          page_path: window.location.pathname,
        });

        // Also send a custom event to ensure tracking
        window.gtag("event", "page_title_updated", {
          event_category: "Navigation",
          event_label: document.title,
          page_title: document.title,
        });
      }

      // Track page view with Google Tag Manager if available
      if (typeof window !== "undefined" && window.dataLayer) {
        window.dataLayer.push({
          event: "page_view",
          page_title: document.title,
          page_location: window.location.href,
          page_path: window.location.pathname,
        });

        // Also push a custom event for title updates
        window.dataLayer.push({
          event: "page_title_updated",
          page_title: document.title,
          page_location: window.location.href,
          page_path: window.location.pathname,
        });
      }

      // Debug logging (remove in production)
      console.log("Page title updated:", document.title);
      console.log("Current path:", window.location.pathname);
    }, 100);

    // Cleanup function
    return () => {
      clearTimeout(timer);
      // Optional: restore previous title on unmount
      // document.title = previousTitle;
    };
  }, [title, suffix]);
};

export default usePageTitle;
